export const validateEmail = (email) => {
  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  return emailRegex.test(email);
};

export const validatePhone = (phone) => {
  const phoneRegex = /^\+?[\d\s-()]{10,}$/;
  return phoneRegex.test(phone);
}; 

export const validateName = (name) => {
  if (!name.trim()) return false;
  return name.length <= 100;
};

export const validateMessage = (message) => {
  if (!message.trim()) return false;
  return message.length <= 1000;
};